const CTA_GROUP_TYPE = {
	main: 'MAIN',
	default: 'DEFAULT',
	category: 'CATEGORY',
};

export default CTA_GROUP_TYPE;